// extracted by mini-css-extract-plugin
export default {"typography":"Slider_typography__HAOUr"};